import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=6320713a&scoped=true"
import script from "./RuleTable.vue?vue&type=script&lang=js"
export * from "./RuleTable.vue?vue&type=script&lang=js"
import style0 from "./RuleTable.vue?vue&type=style&index=0&id=6320713a&prod&lang=scss"
import style1 from "./RuleTable.vue?vue&type=style&index=1&id=6320713a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320713a",
  null
  
)

export default component.exports